import { useEffect, useState } from 'react'

export function useIsTouchDevice() {
  const [isTouch, setIsTouch] = useState(false)

  useEffect(() => {
    const checkTouch = () => {
      setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0)
    }

    checkTouch()
    window.addEventListener('resize', checkTouch) // Update on resize

    return () => window.removeEventListener('resize', checkTouch)
  }, [])

  return { isTouch }
}
